import { ax } from '@src/utils/axios'
import { BASE_API_URL } from '@src/constants'
import { PackFormType } from '@src/types/PackFormType'

interface Options {
  formType: PackFormType,
  formId: number | string,
  serialId: number,
}

export const apiGetFiles = ({
  formType,
  formId,
  serialId,
}: Options) => {
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/v2/documents/${formType}/${formId}`,
    params: {
      // reqRole, // no role!
      reqSid: serialId,
      reqDev: 'web',
    },
  }
  return ax(options)
}